<template>
  <v-app class="site-app">
    <v-app-bar
      :class="{ scrolled: hasScrolled }"
      app
      :height="desktop ? 120 : 90"
      flat
      color="oldLace"
      id="site-header"
      :elevation="0"
      class="app-bar"
    >
      <div 
        v-if="desktop"
        class="d-flex flex-row desktop-header"
      >
        <div class="d-flex flex-column ml-7">
          <span class="text-h4 font-weight-medium site-name">Darcey Grundy</span>
          <span class="text-subtitle-1 font-weight-regular site-title">
            Pull Requests and Personal Records
          </span>
        </div>
        <div class="d-flex">
          <v-btn 
            text
            v-for="navItem in navItems" 
            :to="`${navItem.link}`"
            :key="navItem.title"
            class="nav-link"
            exact
            :class="{ contactNav: isContactButton(navItem.title) }"
          >
            {{ navItem.title }}
          </v-btn>
        </div>
      </div>
      <div 
        v-else 
        class="d-flex mobile-header"
      >
        <div class="w-100 d-flex justify-space-between align-center px-4 mobile-header">
          <v-app-bar-title>
            <v-btn
              class="font-weight-black ma-0 pa-0"
              href="/pull+requests+and+personal+records"
              elevation="0"
              color="flame"
              :ripple="false"
              id="no-background-hover"
            >
              Pull Requests<br />and Personal Records
            </v-btn>
          </v-app-bar-title>
        </div>
        <v-app-bar-nav-icon 
          @click="drawer = !drawer"
          color="flame"
        />
      </div>
    </v-app-bar>
    <v-navigation-drawer 
        v-model="drawer"
        temporary
        bottom
        class="nav-drawer"
      >
      <v-list 
        v-for="navItem in navItems" 
        :key="navItem.title"
        :href="`${navItem.link}`"
      >
        <v-list-item 
          :to="{ name: navItem.title }"
          link
        >
          <v-list-item-title>{{ navItem.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="pa-0">
      <router-view class="app-router"/>
      <footerPage />
    </v-main>
  </v-app>
</template>

<script>
import { ref } from 'vue';
import footerPage from './components/footer.vue';

export default {
  name: 'App',
  components: {
    footerPage
  },
  data: () => ({
    drawer: ref(false),
    hasScrolled: ref(false),
    navItems: [
      {
        title: 'Home',
        link: '/'
      },
      {
        title: 'Blog',
        link: '/blogs'
      },
      {
       title: 'Projects',
       link: '/projects'
      },
      { 
        title: 'Contact',
        link: '/contact'
      },
    ] 
  }),
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeMount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    desktop() {
      return this.$vuetify.breakpoint.mdAndUp
    },
  },
  methods: {
    handleScroll() {
      this.hasScrolled = window.scrollY > 0;
    },
    isContactButton(navTitle) {
      return navTitle === 'Contact';
    }
  },
};
</script>

<style lang="scss">
.desktop-header {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .nav-link {
    font-family: Bebas Neue !important;
    font-size: 26px;

      .v-ripple__container {
    display: none;
  }
  }
  .v-btn.nav-link span {
    color: black;
    padding: 5px;
  }

  .v-btn.nav-link span:hover {
    background-color: #fce8d6 !important;
    border-radius: 15px;
  }

  .v-btn.nav-link.theme--light {
    padding: 0;
    margin: 0 10px;
    letter-spacing: 0;

    &.contactNav span {
      background-color: var(--v-flame-base) !important;
      color: white;
      padding: 15px 14px;
      border-radius: 15px;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
    }
  }
}

#site-header {
  position: fixed;
  top: 0;
  background: white;
  z-index: 1000;
  transition: box-shadow 0.3s ease;
}

#site-header.scrolled {
  box-shadow: 0 5px 0 rgba(112, 112, 112, 0.72) !important;
}

.v-app-bar {
    display: flex;
    color: var(--v-flame-base) !important;
    
    .site-name {
      font-size: 34px !important;
      font-family: Bebas Neue !important;
      font-weight: 500 !important;
    }

    .site-title {
      font-size: 22px !important;
      font-weight: 400 !important;
      margin-top: -10px !important;
      font-family: Bebas Neue !important;
    }
}

.v-toolbar__content, .v-app-bar-title, .v-btn__content, .site-app {
  background-color: var(--v-oldLace-base) !important;
  width: 100% !important;
}

.mobile-header {
  width: 100%;
}

.nav-drawer {
  z-index: 1200 !important;
  top: 0 !important;
}

.v-navigation-drawer__content {
  background-color: oldlace;

  .v-list-item.v-list-item--active,
  .v-list-item.v-list-item--active.v-list-item--nav {
    background-color: transparent !important;
    color: transparent !important;
    a {
      font-size: 36px;
    }
  }

  .v-list-item--link {
    color: transparent !important;
  }

  .v-list-item {
    font-family: Bebas Neue;
    text-align: center;  

    &__title {
      font-size: 30px;
      color: var(--v-flame-base) !important;
    }
  }
}

#no-background-hover::before {
  text-decoration: underline;   
}

#no-background-hover {
  font-family: Bebas Neue;
  letter-spacing: 1.5px;
  font-size: 17px;  
  background-color: var(--v-oldLace-base) !important;
  color: var(--v-flame-base) !important; 
}

.app-router {
  min-height: 95vh;
}
</style>